/*
  Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except
  in compliance with the License. A copy of the License is located at

      http://aws.amazon.com/apache2.0/

  or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import { combineReducers } from 'redux';
import rooms from './roomsReducer';
import auth from './authReducer';
import chat from './chatReducer';
import users from './usersReducer';
import iot from './iotReducer';
import unreads from './unreadsReducer';

const rootReducer = combineReducers({
  rooms,
  auth,
  chat,
  users,
  iot,
  unreads,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js